import { UPDATE_CATEGORY_REDUCER } from "../actionTypes";

export const categoryReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_CATEGORY_REDUCER:
            state = {
                ...state,
                ...action.payload?.data,
            };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};
